<template>
  <div class="editable-string editing-cell" v-if="isEditing">
    <vs-input color="#2D9CDB" v-model="input">
    </vs-input>
  </div>
  <div v-else class="editable-string">
    {{string}}
  </div>
</template>

<script>

export default {
  props: {
    string: { type: String },
    isEditing: { type: Boolean },
  },
  data() {
    return {
      input: this.string
    }
  },
  watch: {
    input(value) {
      this.$emit("updateValue", value)
    },
    isEditing() {
      this.input = this.string
    }
  },
}
</script>

<style lang="scss" scoped>
.editing-cell {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>
